import React from "react";

function PauseIcon({ fill, ...restProps }) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 1.5C61.263 1.5 78.5 18.737 78.5 40C78.5 61.263 61.263 78.5 40 78.5C18.737 78.5 1.5 61.263 1.5 40C1.5 18.737 18.737 1.5 40 1.5Z"
        fill="white"
        fill-opacity="0.1"
      />
      <path
        d="M40 1.5C61.263 1.5 78.5 18.737 78.5 40C78.5 61.263 61.263 78.5 40 78.5C18.737 78.5 1.5 61.263 1.5 40C1.5 18.737 18.737 1.5 40 1.5Z"
        stroke="white"
        stroke-width="3"
      />
      <path
        d="M29.123 29.6875C29.123 29.1697 29.5428 28.75 30.0605 28.75H34.748C35.2658 28.75 35.6855 29.1697 35.6855 29.6875V50.3125C35.6855 50.8303 35.2658 51.25 34.748 51.25H30.0605C29.5428 51.25 29.123 50.8303 29.123 50.3125V29.6875Z"
        fill="white"
      />
      <path
        d="M44.123 29.6875C44.123 29.1697 44.5428 28.75 45.0605 28.75H49.748C50.2658 28.75 50.6855 29.1697 50.6855 29.6875V50.3125C50.6855 50.8303 50.2658 51.25 49.748 51.25H45.0605C44.5428 51.25 44.123 50.8303 44.123 50.3125V29.6875Z"
        fill="white"
      />
    </svg>
  );
}

export default PauseIcon;
